var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 42,
    viewBox: "0 0 60 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_145982",
    x: 0,
    y: 0,
    width: 60,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78912",
    "data-name": "Group 78912",
    transform: "translate(-4316 16085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104699",
    "data-name": "Group 104699"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4316, -16085)",
    filter: "url(#Rectangle_145982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_145982-2",
    "data-name": "Rectangle 145982",
    transform: "translate(9 6)",
    fill: "none",
    stroke: "#828282",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 24,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 40.5,
    height: 22.5,
    rx: 2.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_64229",
    "data-name": "Path 64229",
    d: "M0,0H5.4L0,5.4Z",
    transform: "translate(4336.149 -16075.5)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64231",
    "data-name": "Path 64231",
    d: "M5.4,0H0L5.4,5.4Z",
    transform: "translate(4350.448 -16075.5)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64230",
    "data-name": "Path 64230",
    d: "M0,0H5.315L0,5.315Z",
    transform: "translate(4336.149 -16058.5) rotate(-90)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64232",
    "data-name": "Path 64232",
    d: "M0,5.315H5.315L0,0Z",
    transform: "translate(4350.535 -16058.5) rotate(-90)",
    fill: "#828282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFit);
export default __webpack_public_path__ + "static/media/Fit.2a2e51977203176ac2628c7abe2eb4a4.svg";
export { ForwardRef as ReactComponent };